import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import { next, selectOnboardedTeam } from '../../../store/onboarding.duck';
import { OnboardingContainer } from '@shared/ui/molecules/OnboardingContainer';
import DoThisLaterButtonRow from '@shared/ui/molecules/DoThisLaterButtonRow';
import { AddTeamMember } from '@shared/ui/organisms/add-team-member/AddTeamMember';
import { selectCurrentUser } from "@shared/store/auth.duck";
import { useTranslation } from "react-i18next";
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';

export default function OnboardTeamMember() {
  const dispatch = useDispatch();
  const onboardedTeam = useSelector(selectOnboardedTeam);
  const currentUser = useSelector(selectCurrentUser);
  const teamToAddTo = useMemo(() => onboardedTeam ?? currentUser?.teamEntity, [onboardedTeam, currentUser]);
  const done = () => dispatch(next());
  const {t} = useTranslation();

  return (
    <OnboardingContainer dataTest="onbarding-teamMember">
      <img className={'onboardingTeamMember__image'} src={'/assets/images/onboarding/shapes-spread.svg'} alt={""} />
      <HeadlineMedium style={{marginBottom: 12}}>{t('onboarding.add-user.title')}</HeadlineMedium>
      <BodyLarge style={{marginBottom: 24}}>{t('onboarding.add-user.message')}</BodyLarge>
      <AddTeamMember onDone={done} hideImages={true} team={teamToAddTo} hideSuccessMessage={true} />
      <div className="onboarding__teamMemberControls">
        <DoThisLaterButtonRow dataTest="onboardTeamMemberSkip" onClick={done}/>
      </div>
    </OnboardingContainer>
  )
}

